import {
    Box
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getNotificationCategories,
    getNotificationHistory,
} from "../../../../actions/notificaciones";
import NotificacionBuscarFilters from "./notificacionBuscarFilters";
import NotificacionHistorialTable from "./notificacionHistorialTable";

const NotificacionBuscarContainer = () => {
    const dispatch = useDispatch();
    const { history, categories, isFetchingHistory } = useSelector((state) => state.notificaciones);

    const [filters, setFilters] = useState({ categoria: "" });

    useEffect(() => {
        dispatch(getNotificationCategories());
        dispatch(getNotificationHistory());
    }, []);

    const handleSearch = () => {
        dispatch(getNotificationHistory(filters.categoria || undefined));
    };

    return (
        <Box p={3}>

            <NotificacionBuscarFilters
                categories={categories}
                categoria={filters.categoria}
                onCategoriaChange={(categoria) => setFilters((prev) => ({ ...prev, categoria }))}
                onSearch={handleSearch}
            />

            <NotificacionHistorialTable
                data={history}
                loading={isFetchingHistory}
                fetchData={handleSearch}
            />
        </Box>
    );
};

export default NotificacionBuscarContainer;
